export const FORMS_MACHINE_ID = 'formsFieldsManagerMachine';

export const formsMachineStates = {
  getInitialConfigState: 'getInitialConfigState',
  getInitialConfigFailureState: 'getInitialConfigFailureState',
  loggedInUserState: 'loggedInUserState',
  notLoggedInUserState: 'notLoggedInUserState',
  optVerificationState: 'optVerificationState',
  newUserLoginState: 'newUserLoginState',
  phoneNumberNotVerifiedState: 'phoneNumberNotVerifiedState',
  getClientAuthCodeState: 'getClientAuthCodeState',
  formSubmitState: 'formSubmitState',
  formEditingState: 'formEditingState',
  loggingOutUserState: 'loggingOutUserState',
  getClientAuthenticationDetailsState: 'getClientAuthenticationDetailsState',
  getProfileDetailsState: 'getProfileDetailsState',
  updateProfileState: 'updateProfileState',
  updateGraphQlFieldsState: 'updateGraphQlFieldsState',
  submitForm: 'submitForm',
  updateUserExtraInfoState: 'updateUserExtraInfoState',
  getCollegePredictorClientAuthCodeState:
    'getCollegePredictorClientAuthCodeState',
  getCollegePredictorClientAuthenticationDetailsState:
    'getCollegePredictorClientAuthenticationDetailsState',
  submitPublicForm: 'submitPublicForm',
  sendBackendTrackEventSegmentApiState: 'sendBackendTrackEventSegmentApiState',
  initializeAuthMachineState: 'initializeAuthMachineState',
  overRideFormSubmission: 'overRideFormSubmission',
  getIbFormSubmissionDetailsState: 'getIbFormSubmissionDetailsState',
  getFormReferralCodeState: 'getFormReferralCodeState',
  trackFormReferralAttemptState: 'trackFormReferralAttemptState'
};

export const formsMachineEvents = {
  getInitialConfigRetryEvent: 'GET_INITIAL_CONFIG_RETRY_EVENT',
  goToOtpVerificationStep: 'GO_TO_OTP_VERIFICATION_STEP',
  onSuccessOtpVerification: 'ON_SUCCESS_OTP_VERIFICATION',
  goToNotLoggedInUserState: 'GO_TO_NOT_LOGGED_IN_USER_STATE',
  onSubmitFormClicked: 'ON_SUBMIT_FORM_CLICKED',
  goToPreviousStep: 'GO_TO_PREVIOUS_STEP',
  goToFormEditingState: 'GO_TO_FORM_EDITING_STATE',
  clearErrorMessage: 'CLEAR_ERROR_MESSAGE',
  goToNextStep: 'GO_TO_NEXT_STEP',
  loggingOutUser: 'LOGGING_OUT_USER',
  goToSubmitFormState: 'GO_TO_SUBMIT_FORM_STATE',
  assignConfigEventsToContext: 'ASSIGN_CONFIG_EVENT_TO_CONTEXT',
  goToUpdateProfileDetailsState: 'GO_TO_UPDATE_PROFILE_DETAILS',
  goToUpdateGraphQlFieldsState: 'GO_TO_UPDATE_GRAPH_QL_FIELDS',
  callEventsFromConfig: 'CALL_EVENTS_FROM_CONFIG',
  goToUpdateUserExtraInfoState: 'Go_TO_UPDATE_USER_EXTRA_INFO_STATE',
  doSelfTransition: 'DO_SELF_TRANSITION',
  sendSuccessEventToDataLayer: 'SEND_SUCCESS_EVENT_TO_DATA_LAYER',
  sendPreRegistrationEventToDataLayer:
    'SEND_PRE_REGISTRATION_EVENT_TO_DATA_LAYER',
  loggedOutUser: 'LOGGED_OUT_USER',
  setGoToNextSteps: 'SET_GO_TO_NEXT_STEPS',
  goToGetCollegePredictorClientAuthCodeState:
    'GO_TO_GET_COLLEGE_PREDICTOR_CLIENT_AUTH_CODE',
  spawnPaginationMachine: 'SPAWN_PAGINATION_MACHINE',
  sendUserVerifiedOtpSegmentEvent: 'SEND_USER_VERIFIED_OTP_SEGMENT_EVENT',
  sendFormSubmitSegmentEvent: 'SEND_FORM_SUBMIT_SEGMENT_EVENT',
  sendRegistrationSuccessSegmentEvent:
    'SEND_REGISTRATION_SUCCESS_SEGMENT_EVENT',
  sendIdentifySegmentEvent: 'SEND_IDENTIFY_SEGMENT_EVENT',
  goToSubmitPublicForm: 'SUBMIT_PUBLIC_FORM',
  onEntryGetOTP: 'ON_ENTRY_GET_OTP',
  onSuccessGetOTP: 'ON_SUCCESS_GET_OTP',
  onErrorGetOTP: 'ON_ERROR_GET_OTP',
  onSuccessGetSignUpOTP: 'ON_SUCCESS_GET_SIGN_UP_OTP',
  doChildMachineSelfTransition: 'DO_CHILD_MACHINE_SELF_TRANSITION',
  sendGAEvent: 'SEND_GA_EVENT',
  sendFrontendSegmentEvent: 'SEND_FRONTEND_SEGMENT_EVENT',
  sendBackendSegmentEvent: 'SEND_BACKEND_SEGMENT_EVENT',
  goToOverRideSubmitFormState: 'GO_TO_OVERRIDE_SUBMIT_FORM_STATE',
  postMessageFormSubmissionSuccess: 'POST_MESSAGE_FORM_SUBMISSION_SUCCESS',
  postMessageOverRideFormSubmissionSuccess:
    'POST_MESSAGE_OVERRIDE_FORM_SUBMISSION_SUCCESS',
  postMessagePublicFormSubmissionSuccess:
    'POST_MESSAGE_PUBLIC_FORM_SUBMISSION_SUCCESS',
  updateFormValuesToContext: 'UPDATE_FORM_VALUES_TO_CONTEXT',
  resetAuthMachine: 'RESET_AUTH_MACHINE',
  getIbFormSubmissionDetails: 'GET_IB_FORM_SUBMISSION_DETAILS',
  updateSelectedTab: 'UPDATE_SELECTED_TAB',
  resendOtpClicked: 'RESEND_OTP_CLICKED'
};

export const formsMachineTags = {
  getInitialConfigLoadingTag: 'getInitialConfigLoadingTag',
  otpApiInitiated: 'otpApiInitiated',
  otpVerifyBtnLoading: 'otpVerifyBtnLoading',
  buttonLoading: 'buttonLoading',
  submitBtnLoading: 'submitBtnLoading',
  formLoading: 'formLoading'
};

export const formsMachineActions = {
  spawnAuthCoreMachine: 'spawnAuthCoreMachine',
  setNextAndSubmitBtnLoadingToTrue: 'setNextAndSubmitBtnLoadingToTrue',
  setIsOtpButtonLoadingToFalse: 'setIsOtpButtonLoadingToFalse',
  setIsOtpButtonLoadingToTrue: 'setIsOtpButtonLoadingToTrue',
  setNextAndSubmitBtnLoadingToFalse: 'setNextAndSubmitBtnLoadingToFalse',
  updateIsOtpSentToUserInContext: 'updateIsOtpSentToUserInContext',
  sendGetOtpCustomEventToDataLayer: 'sendGetOtpCustomEventToDataLayer',
  updateIsNewUserInContextToFalse: 'updateIsNewUserInContextToFalse',
  updateIsNewUserInContextToTrue: 'updateIsNewUserInContextToTrue',
  callEventsFromConfig: 'callEventsFromConfig',
  clearErrorMessageFromContext: 'clearErrorMessageFromContext',
  resetOtp: 'resetOtp',
  assignErrorMessageToContext: 'assignErrorMessageToContext',
  assignChildSelfTransitionToConfigEvents:
    'assignChildSelfTransitionToConfigEvents',
  doChildMachineSelfTransition: 'doChildMachineSelfTransition',
  sendGAEventToDataLayer: 'sendGAEventToDataLayer',
  sendFrontendSegmentEvent: 'sendFrontendSegmentEvent',
  updateFormValuesToContext: 'updateFormValuesToContext',
  sendFormSubmissionSuccessPostMessage: 'sendFormSubmissionSuccessPostMessage',
  sendOverRideFormSubmissionSuccessPostMessage:
    'sendOverRideFormSubmissionSuccessPostMessage',
  setLoginAccessAndRefreshToken: 'setLoginAccessAndRefreshToken',
  sendPublicFormSubmissionSuccessPostMessage:
    'sendPublicFormSubmissionSuccessPostMessage',
  onSuccessGettingIbFormSubmissionDetails:
    'onSuccessGettingIbFormSubmissionDetails',
  assignSelfTransitionToConfigEvents: 'assignSelfTransitionToConfigEvents',
  setCollegePredictorTabsContext: 'setCollegePredictorTabsContext',
  updateSelectedTab: 'updateSelectedTab',
  sendResendOtpEventToDataLayer: 'sendResendOtpEventToDataLayer',
  onSuccessGetFormReferralCode: 'onSuccessGetFormReferralCode',
  onErrorTrackFormReferralAttemptLogEntry:
    'onErrorTrackFormReferralAttemptLogEntry'
};
